import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const OcurrencesMonth = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const rawData = chartData?.ocurrencesMonth || [];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    const series = [
        {
            name: 'Total',
            hidden: true,
            data: rawData.map(item => item?.total ?? 0)
        },
        {
            name: 'Madrugada',
            data: rawData.map(item => item?.horario_madrugada ?? 0)
        },
        {
            name: 'Manhã',
            data: rawData.map(item => item?.horario_manha ?? 0)
        },
        {
            name: 'Tarde',
            data: rawData.map(item => item?.horario_tarde ?? 0)
        },
        {
            name: 'Noite',
            data: rawData.map(item => item?.horario_noite ?? 0)
        },
        {
            name: 'Não Identificado',
            data: rawData.map(item => item?.horario_nao_identificado ?? 0)
        }
    ];

    return (
        <SimpleBars
            title={'Período das Ocorrências (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            tooltipTotals={chartData?.ocurrencesMonth?.map(item => item.total)}
            stacked
            showDataLabels={false}
        />
    );
};
